import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { setCurrentStep } from '../../Reducers/App/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { isStartScreen, Steps } from '../../Reducers/App/Selectors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  largeText: {
    fontSize: '4rem',
    fontWeight: 'bold',
    color: 'white',
    marginTop: '8rem',
  },
});

const StartButton = () => {
  const classes = useStyles();
  const startScreen = useSelector(isStartScreen);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(setCurrentStep(Steps.SYSTEM_SELECT));
  };
  return (
    startScreen && (
      <div className={classes.root}>
        <Button onClick={handleClick}>{t('startNow')}</Button>
      </div>
    )
  );
};

export default StartButton;
